import { ProductRequirementData, ProductRequirementRow } from "./productTableTypes";

const EMPTY_VALUE = "Não informado";

export const buildRequirementRows = (
  requirement: ProductRequirementData
): ProductRequirementRow[] => {
  return requirement.group.map((group, index) => ({
    group,
    time: requirement.time[index] ?? EMPTY_VALUE,
    procedures: requirement.procedures[index] ?? EMPTY_VALUE,
  }));
};